export const parseTime = function (seconds) {
  let hours = `${Math.floor(seconds / 3600)}`;
  let minutes = `${Math.floor(seconds % 3600 / 60)}`;
  let _seconds = `${Math.floor(seconds % 3600 % 60)}`;
  return `${padLeft(hours, 2)}:${padLeft(minutes, 2)}:${padLeft(_seconds, 2)}`;
};

export const padLeft = function (string, total) {
  if (typeof string !== 'string') {
    throw new Error('First parameter must be a string');
  }
  if (typeof total !== 'number') {
    throw new Error('Second parameter must be a integer');
  }
  return new Array(total - string.length + 1).join('0') + string;
};

export const replaceAndTrim = function (word) {
  return word.replace(/<br\s*[/]?>/gi, '').replace(/\n/gi, '').trim();
};

export const getClearWordFromTranscript = function (word) {
  // Wat??? If anyone figures out what the point of this replace is, can you please
  // add a note for future developers
  return replaceAndTrim(word).replace(/:$/, '');
};



// This method will always return the same color for a given speaker name.
export const getSpeakerColor = (speakerName) => {
  const returnValue = (
    (
      // Get the product of the binary values of the first three characters
      // of the speaker name. (Watch out for shorter speaker names...)
      speakerName.charCodeAt(0) *
      (speakerName.charCodeAt(1) || 1) *
      (speakerName.charCodeAt(2) || 1)
    )
    // Then get the modulus of 4095 (or the remainder of #fff)
    % 4095
  )
  // And convert to a hex representation.
    .toString(16);
  return `#${returnValue}`;
};

export const sortByField = function (fieldName) {
  const { sortOrder, field } = getFieldAndOrder(fieldName);
  return function (a, b) {
    var result = (a[field] < b[field]) ? -1 : (a[field] > b[field]) ? 1 : 0;
    return result * sortOrder;
  };
};

export const getFieldAndOrder = function (field) {
  var sortOrder = 1;
  if (field[0] === '-') {
    sortOrder = -1;
    field = field.substr(1);
  }
  return {sortOrder, field}
};

export const parseMediaType = function (type) {
  if (type.indexOf('audio') > -1) {
    return 'audio';
  }
  else if (type.indexOf('video') > -1) {
    return 'video';
  }
  else return type;
};
